import { getThunkAndSlice } from "@src/store/getThunkAndSlice";
import { IMandatoryNotification } from "./mandatoryNotification";

const initialState = new Array<IMandatoryNotification>();

export const { thunk: getMandatoryNotifications, slice: getMandatoryNotificationsSlice } = getThunkAndSlice<
	object,
	typeof initialState
>({
	initialState,
	path: "/api/Notifications/GetMandatoryNotifications",
});
